export default {
  'tour.name': 'نام تور',
  'tour.fa.name': '(نام تور(به فارسی',
  'tour.en.name': 'نام تور(به انگلیسی)',
  'tour.englishTourName': 'نام تور (به انگلیسی)',
  'tour.persianTourName': 'نام تور ( به فارسی )',
  'tour.necessities': 'موارد ضروری',
  'tour.fa.necessities': 'موارد ضروری به فارسی',
  'tour.fa.en.necessities': 'موارد ضروری به انگلیسی',
  'tour.englishNecessities': 'وسایل ضروری مورد نیاز در سفر ( به انگلیسی )',
  'tour.persianNecessities': 'وسایل ضروری مورد نیاز در سفر ( به فارسی )',
  'tour.englishDescription': 'توضیحات مورد نیاز برای سفر ( به انگلیسی )',
  'tour.persianDescription': 'توضیحات مورد نیاز برای سفر ( به فارسی )',
  'tour.moneyUnit': 'واحد پول',
  'tour.price': 'قیمت',
  'tour.setPrice': 'تعیین قیمت',
  'tour.type': 'نوع تور',
  'tour.registerDate': 'تاریخ ثبت',
  'tour.whether': 'آب و هوا',
  'tour.tourCondition': 'شرایط تور',
  'tour.capacity': 'ظرفیت تعداد افراد در تور',
  'tour.passengerTypes': 'نوع مسافر',
  'tour.choosePassengerTypes': 'انتخاب نوع مسافر',
  'tour.duration': 'مدت  زمان تور (روز)',
  'tour.destination': 'مقصد',
  'tour.destinationCity': 'شهر مقصد',
  'tour.destinationCountry': 'کشور مقصد',
  'tour.fa.destination': 'نام مقصد به فارسی',
  'tour.fa.en.destination': ' نام مقصد به انگلیسی',
  'tour.departure': 'مبدا',
  'tour.departureCity': 'شهر مبدا',
  'tour.departureCountry': 'کشور مبدا',
  'tour.fa.departure': 'نام مبدا به فارسی',
  'tour.fa.en.departure': ' نام مبدا به انگلیسی',
  'tour.difficultyRate': 'میزان سختی تور',
  'tour.departureDate': 'زمان شروع حرکت تور',
  'tour.description': 'توضیحات',
  'tour.fa.description': 'توضیحات به فارسی',
  'tour.en.description': 'توضیحات به انگلیسی',
  'tour.en.description': 'توضیحات به انگلیسی',
  'tour.limitaions': 'محدودیت ها',
  'tour.fa.limitaions': 'محدودیت ها به فارسی',
  'tour.fa.en.limitaions': 'محدودیت ها به انگلیسی',
  'tour.englishlimitaions': 'محدودیت های سفر ( به انگلیسی )',
  'tour.persianlimitaions': 'محدودیت های سفر ( به فارسی )',
  'tour.international': 'بین المللی',
  'tour.domestic': 'داخلی',
  'tour.addTour': 'ایجاد تور جدید',
  'tour.easy': 'آسان',
  'tour.amature': 'نسبتا آسان',
  'tour.normal': 'معمولی',
  'tour.hard': 'سخت',
  'tour.veryHard': 'بسیار سخت',
  'tour.transportTypes': 'نوع حمل و نقل',
  'tour.chooseTransportTypes': 'انتخاب نوع حمل و نقل',
  'tour.road': 'زمینی',
  'tour.flight': 'هوایی',
  'tour.marine': 'دریایی',
  'tour.surpriseTour': 'نور ناکجا آباد',
  'tour.ordinaryTour': 'تور معمولی',
  'tour.next': 'مرحله بعد',
  'tour.home': 'خانه',
  'tour.confirm': 'تایید',
  'tour.previous': 'مرحله قبل',
  'tour.active': 'فعال',
  'tour.disable': 'غیر فعال',
  'tour.dollar': 'US Dollar',
  'tour.euro': 'Euro',
  'tour.rial': 'ريال',
  'tour.stepOne': 'مرحله اول',
  'tour.stepTwo': 'مرحله دوم',
  'tour.stepThree': 'مرحله سوم',
  'tour.stepFour': 'مرحله چهارم',
  'tour.stepFive': 'مرحله پنجم',
  'tour.details': 'جزئیات',
  'tour.tourDetails': 'جزئیات تور',
  'tour.cancel': 'لغو',
  'tour.chooseTourType': 'نوع تور را اتخاب کنید',
  'tour.save': 'ذخیره موقت',
  'tour.tourDetail': 'اطلاعات تور',
  'tour.furtherInformation': 'اطلاعات تکمیلی',
  'tour.toddlerinownsitPrice': 'قیمت برای نوزاد با صندلی جدا',
  'tour.infantPrice': 'قیمت برای نوزاد',
  'tour.childPrice': 'قیمت برای خردسال',
  'tour.adultPrice': 'قیمت برای دانشجو',
  'tour.studentPrice': 'قیمت برای بزرگسال',
  'tour.seniorcitizenPrice': 'قیمت برای سنیور سیتیزن',
  'tour.bookingDeadline': 'مهلت ثبت نام برای تور',
  'tour.fa.name': '(نام تور(به فارسی',
  'tour.en.name': 'نام تور(به انگلیسی)',
  'tour.englishTourName': 'نام تور (به انگلیسی)',
  'tour.persianTourName': 'نام تور ( به فارسی )',
  'tour.necessities': 'موارد ضروری',
  'tour.fa.necessities': 'موارد ضروری به فارسی',
  'tour.fa.en.necessities': 'موارد ضروری به انگلیسی',
  'tour.englishNecessities': 'وسایل ضروری مورد نیاز در سفر ( به انگلیسی )',
  'tour.persianNecessities': 'وسایل ضروری مورد نیاز در سفر ( به فارسی )',
  'tour.englishDescription': 'توضیحات مورد نیاز برای سفر ( به انگلیسی )',
  'tour.persianDescription': 'توضیحات مورد نیاز برای سفر ( به فارسی )',
  'tour.moneyUnit': 'واحد پول',
  'tour.price': 'قیمت',
  'tour.setPrice': 'تعیین قیمت',
  'tour.type': 'نوع تور',
  'tour.registerDate': 'تاریخ ثبت',
  'tour.whether': 'آب و هوا',
  'tour.tourCondition': 'شرایط تور',
  'tour.capacity': 'ظرفیت تعداد افراد در تور',
  'tour.passengerTypes': 'نوع مسافر',
  'tour.choosePassengerTypes': 'انتخاب نوع مسافر',
  'tour.duration': 'مدت  زمان تور (روز)',
  'tour.destination': 'مقصد',
  'tour.destinationCity': 'شهر مقصد',
  'tour.destinationCountry': 'کشور مقصد',
  'tour.fa.destination': 'نام مقصد به فارسی',
  'tour.fa.en.destination': ' نام مقصد به انگلیسی',
  'tour.departure': 'مبدا',
  'tour.departureCity': 'شهر مبدا',
  'tour.departureCountry': 'کشور مبدا',
  'tour.fa.departure': 'نام مبدا به فارسی',
  'tour.fa.en.departure': ' نام مبدا به انگلیسی',
  'tour.difficultyRate': 'میزان سختی تور',
  'tour.departureDate': 'زمان شروع حرکت تور',
  'tour.description': 'توضیحات',
  'tour.fa.description': 'توضیحات به فارسی',
  'tour.fa.en.description': 'توضیحات به انگلیسی',
  'tour.limitaions': 'محدودیت ها',
  'tour.fa.limitaions': 'محدودیت ها به فارسی',
  'tour.fa.en.limitaions': 'محدودیت ها به انگلیسی',
  'tour.englishlimitaions': 'محدودیت های سفر ( به انگلیسی )',
  'tour.persianlimitaions': 'محدودیت های سفر ( به فارسی )',
  'tour.international': 'بین المللی',
  'tour.domestic': 'داخلی',
  'tour.addTour': 'ایجاد تور جدید',
  'tour.easy': 'آسان',
  'tour.amature': 'نسبتا آسان',
  'tour.normal': 'معمولی',
  'tour.hard': 'سخت',
  'tour.veryHard': 'بسیار سخت',
  'tour.transportTypes': 'نوع حمل و نقل',
  'tour.chooseTransportTypes': 'انتخاب نوع حمل و نقل',
  'tour.road': 'زمینی',
  'tour.flight': 'هوایی',
  'tour.marine': 'دریایی',
  'tour.surpriseTour': 'نور ناکجا آباد',
  'tour.ordinaryTour': 'تور معمولی',
  'tour.next': 'مرحله بعد',
  'tour.home': 'خانه',
  'tour.confirm': 'تایید',
  'tour.previous': 'مرحله قبل',
  'tour.active': 'فعال',
  'tour.disable': 'غیر فعال',
  'tour.dollar': 'US Dollar',
  'tour.euro': 'Euro',
  'tour.rial': 'ريال',
  'tour.stepOne': 'مرحله اول',
  'tour.stepTwo': 'مرحله دوم',
  'tour.stepThree': 'مرحله سوم',
  'tour.stepFour': 'مرحله چهارم',
  'tour.stepFive': 'مرحله پنجم',
  'tour.details': 'جزئیات',
  'tour.tourDetails': 'جزئیات تور',
  'tour.cancel': 'لغو',
  'tour.chooseTourType': 'نوع تور را اتخاب کنید',
  'tour.save': 'ذخیره موقت',
  'tour.tourDetail': 'اطلاعات تور',
  'tour.furtherInformation': 'اطلاعات تکمیلی',
  'tour.toddlerinownsitPrice': 'قیمت برای نوزاد با صندلی جدا',
  'tour.infantPrice': 'قیمت برای نوزاد',
  'tour.childPrice': 'قیمت برای خردسال',
  'tour.adultPrice': 'قیمت برای دانشجو',
  'tour.studentPrice': 'قیمت برای بزرگسال',
  'tour.seniorcitizenPrice': 'قیمت برای سنیور سیتیزن',
  'tour.bookingDeadline': 'مهلت ثبت نام برای تور',

  'tour.climateType': ' آب و هوا در طول سفر',
  'tour.step': 'مرحله ',
  'tour.tourclimateTitle': 'انتخاب اقلیم تور',
  'tour.tourclimateDescription': 'لطفا اقلیم درخواستی خود را انتخاب نمایید',
  'tour.tourtypeTitle': 'انتخاب نوع تور',
  'tour.tourtypeDescription': 'لطفا نوع تور مورد نظر خود را انتخاب نمایید',
  'tour.tourtransfertypeTitle': ' نوع حمل و نقل تور',
  'tour.tourtransfertypeDescription': 'لطفا نوع حمل و نقل خود را انتخاب کنید',
  'tour.tourpassengertypeTitle': ' نوع مسافر',
  'tour.tourpassengertypeDescription':
    'لطفا نوع مسافران مد نظر خود را وارد نمایید',
  'tour.tourinformationTitle': 'اطلاعات تور',
  'tour.tourinformationDescription':
    'لطفا اطلاعات تور را به طور کامل وارد نمایید.',
  'tour.tourpriceTitle': 'قیمت تور ',
  'tour.tourpriceDescription': 'لطفا قیمت تور را براساس مسافران وارد نمایید',
  'tour.tourScheduling': 'زمان بندی تور',
  'tour.mainTourInformation': 'اطلاعات اصلی تور',
  'tour.tourConditions': 'شرایط تور',
  'tour.tourRestrictionsRequirements': 'محدودیت ها و ضروریات تور',
  'tour.tourRegistration': 'ثبت تور',
  'tour.overview': 'بازبینی کلی ',
  'tour.tourInformationTemporarilyRecorded':
    'اطلاعات تور به صورت موقت ثبت گردیده است ',
  'tour.yourTourSuccessfullyRegistered': 'تور مد نظر شما با موفقیت ثبت گردید',
  'tour.addNewTour': 'ثبت تور جدید',
  'tour.climateType': ' آب و هوا در طول سفر',
  'tour.step': 'مرحله ',
  'tour.tourclimateTitle': 'انتخاب اقلیم تور',
  'tour.tourclimateDescription': 'لطفا اقلیم درخواستی خود را انتخاب نمایید',
  'tour.tourtypeTitle': 'انتخاب نوع تور',
  'tour.tourtypeDescription': 'لطفا نوع تور مورد نظر خود را انتخاب نمایید',
  'tour.tourtransfertypeTitle': ' نوع حمل و نقل تور',
  'tour.tourtransfertypeDescription': 'لطفا نوع حمل و نقل خود را انتخاب کنید',
  'tour.tourpassengertypeTitle': ' نوع مسافر',
  'tour.tourpassengertypeDescription':
    'لطفا نوع مسافران مد نظر خود را وارد نمایید',
  'tour.tourinformationTitle': 'اطلاعات تور',
  'tour.tourinformationDescription':
    'لطفا اطلاعات تور را به طور کامل وارد نمایید.',
  'tour.tourpriceTitle': 'قیمت تور ',
  'tour.tourpriceDescription': 'لطفا قیمت تور را براساس مسافران وارد نمایید',
  'tour.tourScheduling': 'زمان بندی تور',
  'tour.mainTourInformation': 'اطلاعات اصلی تور',
  'tour.tourConditions': 'شرایط تور',
  'tour.tourRestrictionsRequirements': 'محدودیت ها و ضروریات تور',
  'tour.tourRegistration': 'ثبت تور',
  'tour.overview': 'بازبینی کلی ',
  'tour.tourInformationTemporarilyRecorded':
    'اطلاعات تور به صورت موقت ثبت گردیده است ',
  'tour.yourTourSuccessfullyRegistered': 'تور مد نظر شما با موفقیت ثبت گردید',
  'tour.addNewTour': 'ثبت تور جدید',

  'tour.touroverviewTitle': 'بازبینی کلی تور',
  'tour.touroverviewDescription':
    'تور خور در را به طور کلی بازیبنی و در صورت نیاز ویرایش نمایید',
  'tour.touroverviewTitle': 'بازبینی کلی تور',
  'tour.touroverviewDescription':
    'تور خور در را به طور کلی بازیبنی و در صورت نیاز ویرایش نمایید',

  'tour.tourpassengertype': 'نوع مسافر',
  'tour.tourtransfertype': ' حمل و نقل تور',
  'tour.tourType': 'نوع تور',
  'tour.nameen': 'نام تور (به انگلیسی )',
  'tour.namefa': 'نام تور (به فارسی)',
  'tour.bookingDeadLine': 'مهلت ثبت نام برای تور',
  'tour.climateTypes': 'نوع آب و هوای تور',
  'tour.limitationsen': 'محدودیت های سفر ( به انگلیسی )',
  'tour.limitationsfa': 'محدودیت های سفر ( به فارسی )',
  'tour.necessitiesen': 'وسایل ضروری مورد نیاز در سفر ( به انگلیسی )',
  'tour.necessitiesfa': 'وسایل ضروری مورد نیاز در سفر ( به فارسی )',
  'tour.descriptionen': 'توضیحات مورد نیاز برای سفر ( به انگلیسی )',
  'tour.descriptionfa': 'توضیحات مورد نیاز برای سفر ( به فارسی )',
  'tour.editTourTransferType': 'ویرایش اطلاعات مربوط به حمل و نقل تور',
  'tour.editTourPassengerType':
    'ویرایش اطلاعات مربوط به مسافر و قیمت های مربوط به هر مسافر',
  'tour.editTourInformation': 'ویرایش اطلاعات کلی تور',
  'tour.tourRegistration': 'ثبت تور',
  'tour.isActive': 'فعالیت',
  'tour.editTourPassengerType': 'ویرایش نوع مسافران تور',
  'tour.editTourTransferType': 'ویرایش نوع حمل و نقل تور',
  'tour.editTourInformationType': 'ویرایش اطلاعات تور',
  'tour.editTourPrice': 'ویرایش قیمت مسافران',
  'tour.attachments': 'پیوست ها',
  'tour.cancelingRules': 'قوانین کنسلی',
  'tour.tourpassengertype': 'نوع مسافر',
  'tour.tourtransfertype': ' حمل و نقل تور',
  'tour.tourType': 'نوع تور',
  'tour.nameen': 'نام تور (به انگلیسی )',
  'tour.namefa': 'نام تور (به فارسی)',
  'tour.bookingDeadLine': 'مهلت ثبت نام برای تور',
  'tour.climateTypes': 'نوع آب و هوای تور',
  'tour.limitationsen': 'محدودیت های سفر ( به انگلیسی )',
  'tour.limitationsfa': 'محدودیت های سفر ( به فارسی )',
  'tour.necessitiesen': 'وسایل ضروری مورد نیاز در سفر ( به انگلیسی )',
  'tour.necessitiesfa': 'وسایل ضروری مورد نیاز در سفر ( به فارسی )',
  'tour.descriptionen': 'توضیحات مورد نیاز برای سفر ( به انگلیسی )',
  'tour.descriptionfa': 'توضیحات مورد نیاز برای سفر ( به فارسی )',
  'tour.editTourTransferType': 'ویرایش اطلاعات مربوط به حمل و نقل تور',
  'tour.editTourPassengerType':
    'ویرایش اطلاعات مربوط به مسافر و قیمت های مربوط به هر مسافر',
  'tour.editTourInformation': 'ویرایش اطلاعات کلی تور',
  'tour.tourRegistration': 'ثبت تور',
  'tour.isActive': 'فعالیت',
  'tour.editTourPassengerType': 'ویرایش نوع مسافران تور',
  'tour.editTourTransferType': 'ویرایش نوع حمل و نقل تور',
  'tour.editTourInformationType': 'ویرایش اطلاعات تور',
  'tour.editTourPrice': 'ویرایش قیمت مسافران',
  'tour.attachments': 'پیوست ها',
  'tour.cancelingRules': 'قوانین کنسلی',

  'tour.endBookingDeadLine': 'پایان مهلت زمانی برای ثبت نام',
  'tour.endPrice': 'پایان قیمت ',
  'tour.startPrice': 'شروع قیمت',
  'tour.endDuration': 'پایان مدت زمان تور(روز)',
  'tour.startDuration': 'شروع مدت زمان تور (روز)',
  'tour.endDepartureDate': 'پایان تاریخ زمان شروع  حرکت تور',
  'tour.startDepartureDate': 'تاریخ زمان شروع جرکت تور ',
  'tour.tour': 'تور',
  'tour.sortby': 'مرتب سازی بر اساس',
  'tour.search': 'جستجو',
  'tour.nameoftour': 'نام تور مورد نظر ...',
  'tour.price': 'قیمت',
  'tour.type': 'نوع سفر',
  'tour.selectdate': 'تاریخ تور خود را انتخاب کنید',
  'tour.newest': 'جدیدترین',
  'tour.cheapest': 'ارزانترین',
  'tour.lowestduration': 'کمترین مدت اقامت',
  'tour.highestduration': 'بیشترین مدت اقامت',
  'tour.all': 'همه',
  'tour.more': 'جزئیات بیشتر',
  'tour.irr': 'ریال',
  'tour.usd': 'دلار',
  'tour.tourfound': 'تور یافت شد',
  'tour.origin': 'مبداٌ',
  'tour.agerange': 'محدوده سنی',
  'tour.date': 'تاریخ',
  'tour.operator': 'ارائه دهنده',
  'tour.necessities': 'موارد الزامی',
  'tour.reserve': 'رزرو تور',
  'tour.amazingtour': 'تور شگفت انگیز',
  'tour.tourfrom': '  تور از ',
  'tour.difficultyrate': '(درجه سختی)',
  'tour.measure': 'اعمال فیلتر',
  'tour.domesticName': 'نام محلی تور',
  'tour.count': 'تعداد نفر',
  'tour.originterminal': 'ترمینال مبدا',
  'tour.destinationterminal': 'ترمینال مقصد',
  'tour.vehicletype': 'وسیله نقلیه',
  'tour.starttime': 'ساعت حرکت',
  'tour.endtime': 'ساعت پایان',
  'tour.invalidreturndate': 'تاریخ برگشت از تاریخ رفت کوچکتر است',
  'tour.invalidstartdate': 'تاریخ رفت از تاریخ برگشت بزرگتر است',
  'tour.invalidstartdate': 'تاریخ رفت از تاریخ برگشت بزرگتر است',
  'tour.facilities': 'امکانات تور',
  'tour.invalidEndTime': 'ساعت پایان کمتر از ساعت شروع',
  'tour.drafts': 'پیش نویس',
  'tour.useprevioustours': 'استفاده از تورهای پیشین',
  'tour.Draft': 'تورهای پیش نویس شده',
  'tour.creationDate': 'تاریخ ایجاد',
  'tour.dateCreatedFrom': 'تاریخ ایجاد از',
  'tour.dateCreatedUntil': 'تاریخ ایجاد تا',
  'tour.ordering': 'مرتب سازی',
  'tour.basedTourName': 'براساس نام تور ',
  'tour.basedNamePlace': 'براساس نام مکان',
  'tour.search': 'جستجو براساس نام و مکان',
  'tour.facilitynotdeclared': 'امکانات مشخص نشده است',
  'tour.basicinfonotfound': 'اطلاعات تور مشخص نشده است',
  'tour.finaldestination': 'مقصد نهایی',
  'tour.insertdraft': 'ثبت پیش نویس',
  'tour.updatetdraft': 'به روز رسانی پیش نویس',
  'tour.ageSuffering': 'رنج سنی',
  'tour.finaldestination': 'مقصد نهایی',
  'tour.insertsuccess': 'تور با موفقیت ثبت گردید',
  'tour.draftinsertsuccess': 'پیش نویس تور با موفقیت ثبت گردید',
  'tour.inserterror': 'ثبت تور ناموفق بود',
  'tour.updatesuccess': 'تور با موفقیت به روز شد',
  'tour.draftupdatesuccess': 'پیش نویس تور با موفقیت به روز شد',
  'tour.updateerror': 'به روز رسانی تور ناموفق بود',
  'tour.deletesuccess': 'تور با موفقیت حذف گردید',
  'tour.draftdeletesuccess': 'پیش‌نویس تور با موفقیت حذف شد',
  'tour.deleteerror': 'حذف تور ناموفق بود',
  'tour.deletedrafttour': 'حذف تور پیش نویس شده',
  'tour.deletedrafttourmessage': 'آیا از حذف تور پیش نویس شده مطمئن هستید؟',
  'tour.male': 'مرد',
  'tour.female': 'زن',
  'tour.all': 'همه',
  'tour.changefieldwarning':
    'در صورت اعمال تغییر در فیلدهای مهم اطلاعات مراحل بعد حذف خواهد شد. برای اطلاعات بیشتر کلیک کنید',
  'tour.importantfieldsintroduction':
    'اعمال تغییرات در فیلدهای زیر باعث از بین رفتن اطلاعات فرم های بعدی می شود',
  'tour.tournotspecified': 'اطلاعات تور مشخص نشده است',
  'tour.stoptype': 'نوع توقف',
  'tour.searchfacilities': 'جستجوی امکانات',
  'tour.confirmdata': 'تمامی اطلاعات ثبت شده مورد تایید است',
  'tour.vehiclenamefa': 'نام محلی وسیله نقلیه',
  'tour.vehiclenameen': 'نام انگلیسی وسیله نقلیه',
  'tour.transportproviderlocal': 'نام محلی ارائه دهنده حمل و نقل',
  'tour.transportprovideren': 'نام انگلیسی ارائه دهنده حمل و نقل',
  'tour.addnewtourtype': 'افزودن نوع تور جدید',
  'tour.submittourtype': 'ثبت نوع تور جدید',
  'tour.tourtypenamefa': 'نام فارسی نوع تور',
  'tour.tourtypenameen': 'نام انگلیسی نوع تور',
  'tour.tourtypeinsertsuccess': 'ثبت با موفقیت انجام شد',
  'tour.tourtypeinserterror': 'ثبت  ناموفق',
  'tour.originairport': 'فرودگاه مبدا',
  'tour.destinationairport': 'فرودگاه مقصد',
  'tour.arrivaldateto': 'تاریخ ورود',
  'tour.arrivaltimeto': 'زمان رسیدن',
  'tour.nextmovedate': 'تاریخ شروع حمل و نقل بعدی',
  'tour.nextmovetime': 'زمان شروع حمل و نقل بعدی',
  'tour.tourimages': 'تصاویر تور',
  'tour.viewimages': 'مشاهده تصاویر',
  'tour.addnewtourfacility': 'افزودن امکانات جدید تور',
  'tour.tourfacilitynamefa': 'نام فارسی امکانات تور',
  'tour.tourfacilitynameen': 'نام انگلیسی امکانات تور',
  'tour.originterminalfa': 'نام محلی ترمینال مبدا',
  'tour.originterminalen': 'نام انگلیسی ترمینال مبدا',
  'tour.destinationterminalfa': 'نام محلی ترمینال مقصد',
  'tour.destinationterminalen': 'نام انگلیسی ترمینال مقصد',
  'tour.underreviewing': 'در حال بررسی',
  'tour.expired': 'منقضی شده',
  'tour.residence': 'اقامتگاه',
  'tour.pricepercustomer': 'قیمت برای هر نفر',
  'tour.userstours': 'تورهای من',
  'tour.usersalltours': 'همه ی تورها',
  'tour.usersactivetours': 'تورهای فعال',
  'tour.usersexpiredtours': 'تورهای منقضی شده',
  'tour.changerequiredfields': 'نمایش نتیجه بررسی اپراتور',
  'tour.requiredreviews': 'بررسی های مورد نیاز',
  'tour.rejectionreason': 'دلیل عدم تایید',
  'tour.rejectiondescription': 'توضیحات عدم تایید',
  'tour.starttime': 'ساعت شروع',
  'tour.endtime': 'ساعت پایان',
  'tour.imageuploadfailed': 'آپلود تصویر ناموفق بود',
};
